import { Injectable } from '@angular/core';
import { KeycloakService } from 'app/login/keycloak.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class HeaderService {

  getHttpHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }
}
